import { cn } from '@/utils/helpers/classnames';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
  className?: string;
}

export function Toggle({
  checked,
  onChange,
  label,
  description,
  disabled = false,
  className = ''
}: ToggleProps) {
  return (
    <div className={cn("flex items-center justify-between gap-4", className)}>
      <div>
        <p className="text-base font-semibold text-[#1E3A5F]">{label}</p>
        {description ? <p className="mt-1 text-sm text-[#4A6180]">{description}</p> : null}
      </div>

      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <div className="h-6 w-12 rounded-full bg-gray-300 transition-colors peer-checked:bg-[#951F39] peer-disabled:opacity-60"></div>
        <div className="absolute left-1 top-1 h-4 w-4 rounded-full border border-gray-200 bg-white transition-transform peer-checked:translate-x-6"></div>
      </label>
    </div>
  );
}

export default Toggle;
